import type { ResponseInterceptor } from "@/app/api";
import { EnumBillingPlanStatus } from "@/app/services/generated/enums/enumBillingPlanStatus.generated";
import { EnumStockLevelDisplay } from "@/app/services/generated/enums/enumStockLevelDisplay.generated";
import type { EnumTpPaymentMethod } from "@/app/services/generated/enums/enumTpPaymentMethod.generated";
import type { TpTenant } from "@/app/services/generated/tradeportalService";
import type Guid from "@/app/types/common/guid";

const emptyTenant = {
  storeName: "",
  storeCode: "",
  tenantId: null as Guid | null,
  telephoneNumber: "",
  emailAddress: "",
  website: "",
  address: "",
  currencySymbolPrefix: "",
  currencyMaxDecimalPlaces: 2,
  currencySymbolSuffix: "",
  stripePublicApiKey: "",
  stockLevelDisplay: EnumStockLevelDisplay.off,
  lowStockThreshold: null as number | null,
  paymentMethods: [] as EnumTpPaymentMethod[],
  billingStatus: EnumBillingPlanStatus.trialling,
  termsAndConditionsLink: "",
};

export class TpSessionData {
  private _sessionToken = "";
  private _tenant = null as TpTenant | null;
  private _isMorphedUser = false;
  public responseInterceptors: ResponseInterceptor[] = [];

  public get sessionToken() {
    return this._sessionToken;
  }

  public get tenant() {
    return this._tenant;
  }

  public setSession(sessionToken: string) {
    this._sessionToken = sessionToken;
  }

  public setStore(tenant: TpTenant | null) {
    this._tenant = tenant;
  }

  public get tenantOrDefault(): typeof emptyTenant {
    return this._tenant ?? emptyTenant;
  }

  public get isMorphedUser() {
    return this._isMorphedUser;
  }

  public setIsMorphedUser(isMorphedUser: boolean) {
    this._isMorphedUser = isMorphedUser;
  }
}

const tpSessionData = new TpSessionData();

export { tpSessionData };
